export default {
    bind (el, binding, vnode) {
    },
    inserted (el, binding, vnode) {
    },
    update (el, binding, vnode) {
        let value_new = el.value.replace(/\n/g, '')
            if (value_new !== el.value) {
                el.value = value_new
                    el.dispatchEvent(new Event('input', { bubbles: true, }))
            }
    },
    componentUpdated (el, binding, vnode) {
    },
    unbind (el, binding, vnode) {
    },
}


